import { render, staticRenderFns } from "./MultiIcon.vue?vue&type=template&id=1850725b&scoped=true&"
import script from "./MultiIcon.vue?vue&type=script&lang=js&"
export * from "./MultiIcon.vue?vue&type=script&lang=js&"
import style0 from "./MultiIcon.vue?vue&type=style&index=0&id=1850725b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1850725b",
  null
  
)

export default component.exports